import React, { Fragment, useEffect } from 'react'
import { GenericTableV2 } from '../../../components/_EOS/GenericTable/GenericTableV2'
import { useApi } from '../../../hooks/useApi'
import { usePagination } from '../../../hooks/usePagination'
import { VasRule } from '../../../interfaces/VasRule/VasRule'
import { ApiResponse } from '../../../typings/ApiResponse'
import { getVasRuleAvailable } from '../config/api'
import { getColumnsConfigVas } from '../config/tableColumns'
import { Status } from '../../../hooks/useFetchState'
import { Paper } from '@mui/material'

interface VasRuleSkuModalProps {
  skuId: number
  handleSnackbar: (message: string, success: boolean) => void
}

export const VasRuleSkuModal: React.FC<VasRuleSkuModalProps> = ({
  skuId,
  handleSnackbar
}) => {
  const { callApi, state } = useApi<ApiResponse<VasRule>>()

  const pagination = usePagination(5)
  const handlePagination = (page: number, pageSize: number) => {
    const auxPage = pagination.pageSize !== pageSize ? 0 : page
    pagination.setPagination(auxPage, pageSize)
  }
  const columnsConfig = getColumnsConfigVas()

  const requestData = (page: number, pageSize: number, name?: string) => {
    callApi(getVasRuleAvailable(skuId, page, pageSize, name)).catch((error) => {
      handleSnackbar(error, false)
    })
  }

  useEffect(() => {
    requestData(pagination.page, pagination.pageSize)
  }, [pagination.page, pagination.pageSize])

  return (
    <Fragment>
      <Paper
        variant='outlined'
        style={{
          width: '96%',
          padding: 2,
          marginTop: 2
        }}
      >
        <GenericTableV2<VasRule>
          data={state.data?.items || []}
          columns={columnsConfig}
          keyField='vasRuleId'
          loading={state.status === Status.Loading}
          pagination={{
            page: pagination.page,
            pageSize: pagination.pageSize,
            total: state.data?.totalItems || 0,
            onPageChange: handlePagination
          }}
          styling={{
            dense: true,
            hoverEffect: true,
            alternatingRows: true
          }}
        />
      </Paper>
    </Fragment>
  )
}
